const accentEAgu = String.fromCharCode(233);
const accentEGrave = String.fromCharCode(232);
const accentOAgu = String.fromCharCode(243);
const accentC = String.fromCharCode(231);
const accentAAgu = String.fromCharCode(225);
const accentAGrave = String.fromCharCode(224);
const accentUAgu = String.fromCharCode(250);

export default {
	en: {
		title: 'Click to pay invoice',
		errorTitle: 'Oops...',
		paymentSuccessTitle: 'Success!',
		paymentSuccessBody: 'We have received your payment.',
		errorMessage:
			'Something went wrong with your invoice! Please try again.',
		downloadReceipt: 'Download Receipt',
		voidMessage:
			'This invoice has been voided. For more information please contact us.',
		text: 'Text',
		call: 'Call',
		billed: 'Billed to',
		forText: 'for',
		requested: 'Requested on',
		branding: 'Powered by',
		pay: 'Pay',
		download: 'Download Receipt',
		back: 'Back',
		creditCard: 'Pay by Card',
		refundText: 'Refund',
		creditCardText: 'Card',
		date: 'Date',
		type: 'Type',
		detail: 'Detail',
		amount: 'Amount',
		paidBy: 'Paid By',
		receipt: 'Receipt',

		referenceNumber: 'Reference number',
		description: 'Description',
		datePaid: 'Date paid',
		paymentMethod: 'Payment method'
	},
	fr: {
		title: 'Cliquez pour payer la facture',
		errorTitle: 'Euh oh...',
		errorMessage: `Un probl${accentEGrave}me est survenu avec votre facture! Veuillez r${accentEAgu}essayer.`,
		paymentSuccessTitle: `Succ${accentEGrave}s!`,
		paymentSuccessBody: ` Nous avons re${accentC}u votre paiement.`,
		downloadReceipt: `T${accentEAgu}l${accentEAgu}charger le re${accentC}u`,
		voidMessage: `Cette facture a ${accentEAgu}t${accentEAgu} annul${accentEAgu}e. Pour plus d'informations, contactez nous.`,
		text: 'Texte',
		call: 'Appel',
		billed: `Factur${accentEAgu} ${accentAGrave}`,
		forText: 'pour',
		requested: `Demand${accentEAgu}`,
		branding: 'Produit par',
		pay: 'Payer',
		download: `T${accentEAgu}l${accentEAgu}charger le re${accentC}u`,
		back: `Retourner`,
		creditCard: `Payer par carte`,
		refundText: 'Rembourser',
		creditCardText: `Carte`,
		date: 'Date',
		type: 'Type',
		detail: `D${accentEAgu}tail`,
		amount: 'Somme',
		paidBy: `Pay${accentEAgu} par`,
		receipt: `Le re${accentC}u`,
		referenceNumber: `Num${accentEAgu}ro de r${accentEAgu}ference`,
		description: 'La description',
		datePaid: 'Date de paiement',
		paymentMethod: 'Mode de paiement'
	},
	es: {
		title: 'Haga clic para pagar la factura',
		errorTitle: 'Uh oh...',
		errorMessage: `¡Algo sali${accentOAgu} mal con tu factura! Int${accentEAgu}ntalo de nuevo.`,
		paymentSuccessTitle: `¡Éxito!`,
		paymentSuccessBody: `  Hemos recibido su pago.`,
		downloadReceipt: 'Descargar recibo',
		voidMessage: `Esta factura ha sido anulada. Para m${accentAAgu}s informaci${accentOAgu}n cont${accentAAgu}ctenos.`,
		text: 'Texto',
		call: 'Llamada',
		billed: 'Facturado a',
		forText: 'por',
		requested: 'Solicitado en',
		branding: 'Creado por',
		pay: 'Pagar',
		download: `Descargar recibo`,
		back: 'Regresa',
		creditCard: `Pagar con tarjeta`,
		refundText: 'Reembolso',
		creditCardText: `Tarjeta`,
		date: 'Fecha',
		type: 'Tipo',
		detail: 'Detalle',
		amount: 'Cantidad',
		paidBy: 'Pagado por',
		receipt: 'Recibo',
		referenceNumber: `N${accentUAgu}mero de referencia`,
		description: `Descripci${accentOAgu}n`,
		datePaid: 'Fecha de pago',
		paymentMethod: `M${accentEGrave}todo de pago`
	}
};



// WEBPACK FOOTER //
// ./src/utils/dictionary.js